var React = require('react');

function CurveUnderlineInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.3001 63C-66.8949 43 219.646 3 483 3","stroke":"currentColor","strokeWidth":"6px","strokeLinecap":"round"}));
}

CurveUnderlineInline.defaultProps = {"width":"486","height":"66","viewBox":"0 0 486 66","fill":"none"};

module.exports = CurveUnderlineInline;

CurveUnderlineInline.default = CurveUnderlineInline;
